/**
 * Normalizes URL by adding https:// if missing
 * @param {string} url - URL to normalize
 * @returns {string} Normalized URL or empty string
 */
export const normalizeUrl = (url) => {
    if (!url) {
        return '';
    }
    const trimmed = url.trim();
    if (!trimmed) {
        return '';
    }
    if (!/^https?:\/\//i.test(trimmed)) {
        return `https://${trimmed}`;
    }
    return trimmed;
};

